<div class="container">
  <div class="content">
    <div class="center-column">
      <div class="now-account-logo">
        <!-- //to intergrate in mvc App  url is given we need to remove-->
        <img
          class="now-account-logo-img"
          src="/assets/images/Now-Account_with_Mark_2.png"
          alt="NowAccount logo with company name"
        />
      </div>
      <div class="welcome-text">
        <h3>Welcome!</h3>
      </div>
      <app-serverside-alert></app-serverside-alert>
      <div class="registration-link">
        <p>Need a NowAccount?</p>
        <app-stateful-internal-link
          text="Sign up!"
          [pageUrl]="this.signupState['pageUrl']"
          [stateId]="this.signupState['id']"
          style="margin-top: 13px"
        ></app-stateful-internal-link>
      </div>
      <ng-container [formGroup]="this.form">
        <div class="textboxes">
          <app-kendo-textbox
            inputText="{{ this.emailText }}"
            formControlName="email"
            inputType="email"
            [parentForm]="form"
            (keyup.enter)="onEnter()"
          ></app-kendo-textbox>
          <div
            class="parent-invalid-feedback"
            *ngIf="
              this.form.get('email')  ?.invalid &&
              (this.form.get('email')?.dirty || this.form.get('email')?.touched)
            "
          >
            <div class="invalid-feedback">
              <kendo-formerror
                *ngIf="this.form.get('email')?.errors?.['required']"
                >Email is required.
              </kendo-formerror>
              <kendo-formerror *ngIf="this.form.get('email')?.errors?.['email']">
                Not a Valid Email Format
            </kendo-formerror>
            </div>
          </div>
          <app-kendo-password-textbox
            inputText="{{ this.passwordText }}"
            formControlName="password"
            inputType="password"
            [parentForm]="form"
            (keyup.enter)="onEnter()"
          >
          </app-kendo-password-textbox>
          <div
            class="parent-invalid-feedback"
            *ngIf="
              this.form.get('password')?.invalid &&
              (this.form.get('password')?.dirty ||
                this.form.get('password')?.touched)
            "
          >
            <div class="invalid-feedback">
              <kendo-formerror
                *ngIf="this.form.get('password')?.errors?.['required']"
                >Password is required.
              </kendo-formerror>
            </div>
          </div>
        </div>

        <div class="button-wrapper">
          <app-primary-button
            text="{{ this.signInBtnText }}"
            href=""
            [clickEvent]="this.submitForm.bind(this)"
            #submitButton
          >
          </app-primary-button>
        </div>
        <div class="forgetpassword">
          <app-internal-link
            class="addunderline"
            text="Forgot Password?"
            pageUrl="/forgotpassword"
          >
          </app-internal-link>
        </div>
      </ng-container>
      <div class="line-break">
        <hr />
        <span>&nbsp;&nbsp;&nbsp;or&nbsp;&nbsp;&nbsp;</span>
        <hr />
      </div>
      <div class="button-wrapper">
        <app-primary-button
          text="{{ this.intuitBtnText }}"
          href=""
          [clickEvent]="this.signInWithIntuit.bind(this)"
        >
        </app-primary-button>
      </div>
    </div>
  </div>
</div>
